import { render, staticRenderFns } from "./studentsManage.vue?vue&type=template&id=f918b69c&scoped=true"
import script from "./studentsManage.vue?vue&type=script&lang=js"
export * from "./studentsManage.vue?vue&type=script&lang=js"
import style0 from "./studentsManage.vue?vue&type=style&index=0&id=f918b69c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f918b69c",
  null
  
)

export default component.exports